// The Notability brand's own social profiles. These live here rather than alongside the other
// site links in `common-frontend` because they are identity, not navigation: they are published as
// `Organization.sameAs` by every property, including ones with no React runtime, and every
// property has to emit the same list for the profiles to consolidate onto one brand entity.
// `common-frontend`'s `siteLinks` re-exports them for the front ends that link to them in the UI.
export const instagramHref = 'https://instagram.com/notabilityapp'
export const youtubeHref = 'https://www.youtube.com/channel/UCybCzee6J3ewoXqMuE78JVQ'
export const tiktokHref = 'https://www.tiktok.com/@notabilityapp'
export const threadsHref = 'https://www.threads.net/@notabilityapp'
export const linkedinHref = 'https://www.linkedin.com/company/ginger-labs'
export const discordHref = 'https://discord.gg/wUkUu36KYh'
export const redNoteHref = 'https://xhslink.com/m/9dDjNjZYzQC'
export const douyinHref = 'https://www.douyin.com/user/MS4wLjABAAAAa0NLyvOUv2OPo27dJSzYVlRo6YxAK-7pP_JbnbUs1Sk'

// The canonical Notability brand social profiles for `Organization.sameAs`.
export const NOTABILITY_SAME_AS: readonly string[] = [
  instagramHref,
  youtubeHref,
  tiktokHref,
  threadsHref,
  linkedinHref,
  discordHref,
  redNoteHref,
  douyinHref
]
